<div class="view-component-title">{{title}}</div>
<div class="content">
  <form [formGroup]="fillControl" (ngSubmit)="salvar()">
    <div class="fields" *ngFor="let item of fields">
      <div class="tem-field fields-container" *ngIf="item.type!='options'">
        <label class="tem-field-label">{{item.label}}</label>
        <input nz-input [type]="item.type" [formControlName]="item.controlName" [placeholder]="item.label">
        <div class="field-error" *ngIf="fillControl.controls[item.controlName].touched && !fillControl.controls[item.controlName].valid">
          {{ item.mensagem }}
        </div>
      </div>
      <div class="tem-field fields-container" *ngIf="item.type=='options'">
        <label class="tem-field-label">{{item.label}}</label>
        <nz-select [formControlName]="item.controlName" [nzPlaceHolder]="item.label">
          <nz-option *ngFor="let option of item.options" [nzValue]="option.key" [nzLabel]="option.value"></nz-option>
        </nz-select>
        <div class="field-error" *ngIf="fillControl.controls[item.controlName].touched && !fillControl.controls[item.controlName].valid">
          {{ item.mensagem }}
        </div>
      </div>

    </div>
    <div class="options">
      <button nz-button nzDanger id="no-button" type="button" (click)="closeDialog()">Cancelar</button>
      <button nz-button nzType="primary" id="yes-button" type="submit">Salvar</button>
    </div>
  </form>
</div>
